import { h, Component } from 'preact';
import { MkComponent } from 'lib/mkjs/mkcomponent';
import { TownshendUser } from 'lib/townshend/components/townshendentities';
import ContactInfo from "entities/contactinfo";

export default class ContactEntity extends MkComponent {
	getBasePath() {
		return "/contact-entities"
	}

	getFieldComponent(fieldName) {
		const fieldComponents = {
			primaryUser: this._fieldReference(TownshendUser, {nameFunc: item=>item.username}),
			delegateUsers: this._fieldReference(TownshendUser, {nameFunc: item=>item.username}),
			personalContacts: this._fieldReference(ContactInfo, {nameFunc: (item,a)=>{
				return item.label || (item.info && item.info.name ? item.info.name : null) || item.id;
			}}),
			contactInfo: this._fieldReference(ContactInfo, {nameFunc: (item,a)=>{
				return item.label || (item.info && item.info.name ? item.info.name : null) || item.id;
			}}),
		}
		return fieldComponents[fieldName];
	}

	userCan(action) {
		//TODO allow users to edit their entity (add delegates, change type, change visibility?)
		return this.props.userIsAdmin;
	}
}



// WEBPACK FOOTER //
// ./entities/contactentity/index.js